module.exports = __webpack_public_path__ + "static/media/Artikal4.ef95bc54.png";